import React from 'react'
import { DashboardModule } from '@domain-group/suit-theme'

import NavigationItem from './NavigationItem'

type Step = {
  complete?: boolean,
  key: string,
  label: string,
  body: string,
  onClick?: (step: Step) => void,
}

interface StepNavigationProps {
  activeStepKey: string,
  callbacks: {
    setCurrentStepKey: (step: Step) => void,
  },
  allowCompletedStepClickOnly?: boolean,
  disableStepClick?: boolean,
  horizontal?: boolean,
  showTickIcon?: boolean,
  steps: Step[],
}

const StepNavigation = (props: StepNavigationProps) => {
  const {
    activeStepKey,
    allowCompletedStepClickOnly = false,
    callbacks,
    disableStepClick = false,
    horizontal = false,
    showTickIcon = false,
    steps,
  } = props
  const { setCurrentStepKey } = callbacks || {}

  const activeStepIndex = steps.findIndex(step => step.key === activeStepKey)

  return (
    <DashboardModule contentBoxProps={{ flexDirection: horizontal ? 'row' : 'column' }} title="Steps">
      {steps.map((step, index) => {
        const {
          body, complete, key, label,
        } = step
        const isComplete = complete ?? index < activeStepIndex
        const canClickStep = !disableStepClick
          && (!allowCompletedStepClickOnly || isComplete)

        return (
          <NavigationItem
            body={body}
            callbacks={canClickStep ? {
              onClick: () => setCurrentStepKey(step),
            } : undefined}
            isActive={activeStepKey === key}
            isComplete={isComplete}
            isFirst={index === 0}
            isLast={steps.length === index + 1}
            key={key}
            label={label}
            horizontal={horizontal}
            showTickIcon={showTickIcon}
            stepNumber={index + 1}
          />
        )
      })}
    </DashboardModule>
  )
}

StepNavigation.Item = NavigationItem

export default StepNavigation
